"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldWrapperAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FieldLayout = require("../layout/FieldLayout");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldWrapperAdapter = function FieldWrapperAdapter(_ref) {
  var field = _ref.field,
      children = _ref.children,
      isSmall = _ref.isSmall,
      cashbotName = _ref.cashbotName,
      cashbotOptions = _ref.cashbotOptions;
  return _react.default.createElement(_FieldLayout.FieldWrapper, {
    fieldName: field.name,
    isSmall: isSmall,
    cashbotName: cashbotName,
    cashbotOptions: cashbotOptions
  }, children);
};

exports.FieldWrapperAdapter = FieldWrapperAdapter;
FieldWrapperAdapter.defaultProps = {
  isSmall: false,
  cashbotOptions: {}
};
FieldWrapperAdapter.propTypes = {
  field: _propTypes.default.object.isRequired,
  children: _propTypes.default.node.isRequired,
  isSmall: _propTypes.default.bool,
  cashbotName: _propTypes.default.string.isRequired,
  cashbotOptions: _propTypes.default.object
};